import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SiteHeader from "./components/SiteHeader";
import SplashHero from "./sections/SplashHero";
import HuntAndArsenal from "./sections/HuntAndArsenal";
import ScreenshotsRow from "./sections/ScreenshotsRow";
import FooterCTA from "./sections/FooterCTA";
import SeoCopy from "./sections/SeoCopy";
import usePageViewTracking from "./lib/analytics";

function Landing() {
  usePageViewTracking();
  return (
    <div
      className="App relative bg-[hsl(var(--background))] text-[hsl(var(--foreground))]"
      data-testid="landing-page"
    >
      <SiteHeader />
      <main>
        <SplashHero />
        <HuntAndArsenal />
        <ScreenshotsRow />
        <SeoCopy />
      </main>
      <FooterCTA />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}
